/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleNumber6 = createReactComponent("circle-number-6", "IconCircleNumber6", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  [
    "path",
    {
      d: "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3",
      key: "svg-1"
    }
  ]
]);

export { IconCircleNumber6 as default };
//# sourceMappingURL=IconCircleNumber6.js.map
